function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import find from 'lodash/find';
import get from 'lodash/get';
import { getBlsKeyByReturnUrl } from 'helpers/bls';
import { AppContext } from 'context';
import SessionStorage from 'libs/SessionStorage';
import ArrowIcon from 'svg/ap/arrow.svg';
import App from 'modules/App';
import { APPS } from 'modules/Account/constants';
import Link from 'components/Link';
import styles from './BackToMainView.pcss';
var _React_PureComponent;
class BackToMainView extends (_React_PureComponent = React.PureComponent) {
    onClick() {
        if (this.blsReturnUrl) {
            SessionStorage.removeItem('blsReturnUrl');
        }
    }
    render() {
        const message = this.app && !this.props.isMessageFixed ? App.messages.buttons.backToApp : this.props.message;
        const appName = get(this.app, 'name');
        return /*#__PURE__*/ _jsx("div", {
            className: "backToMainView",
            children: /*#__PURE__*/ _jsx("p", {
                className: "text--small mb-5",
                children: /*#__PURE__*/ _jsxs(Link, {
                    to: this.url,
                    className: "d-flex align-items-center text--light",
                    onClick: ()=>this.onClick(),
                    children: [
                        /*#__PURE__*/ _jsx(ArrowIcon, {
                            className: `${styles.arrow} mr-4`
                        }),
                        /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, message), {
                            values: {
                                appName
                            }
                        }))
                    ]
                })
            })
        });
    }
    constructor(props, context){
        super(props);
        this.blsReturnUrl = SessionStorage.getItem('blsReturnUrl');
        if (this.blsReturnUrl) {
            const key = getBlsKeyByReturnUrl(context.bls, this.blsReturnUrl);
            this.app = find(APPS, {
                key
            });
        }
        this.url = this.blsReturnUrl || context.getUrl(props.routeName, props.routeParams);
    }
}
_define_property(BackToMainView, "contextType", AppContext);
_define_property(BackToMainView, "propTypes", {
    // Explicit props
    routeName: PropTypes.string.isRequired,
    routeParams: PropTypes.object,
    message: PropTypes.shape({
        id: PropTypes.string.isRequired
    }),
    isMessageFixed: PropTypes.bool
});
_define_property(BackToMainView, "defaultProps", {
    message: App.messages.buttons.back
});
export default withStyles(styles)(BackToMainView);
